import React from 'react';

import type { CustomOfferFormValues } from '@/typings/formValues';
import { Controller } from 'react-hook-form';
import type { Control, UseFormSetValue } from 'react-hook-form';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import Grid from '@mui/material/Grid';

import {
  CRUISE_POST_PURCHASE_TYPES,
  DEFAULT_CRUISE_POST_PURCHASE_LE_FEE,
  PURCHASE_TYPE_POST_PURCHASE,
  PURCHASE_TYPE_SALES,
} from '../../constants';
import type { PurchaseType } from '../../constants';

type Props = {
  control: Control<CustomOfferFormValues>;
  cruiseLeFee: number;
  disabled: boolean;
  isEditMode: boolean;
  purchaseType: PurchaseType;
  setValue: UseFormSetValue<CustomOfferFormValues>;
};

export default function CruisePostPurchaseTypeFields({
  control,
  cruiseLeFee,
  disabled,
  isEditMode,
  purchaseType,
  setValue,
}: Props) {
  return (
    <>
      <Grid size={{ xs: 3, md: 1 }}>
        <Controller
          name="purchase_type"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <FormControl fullWidth error={!!error}>
              <InputLabel>Custom Offer Type</InputLabel>
              <Select
                {...field}
                label="Custom Offer Type"
                disabled={disabled}
                data-testid="custom-offer-type"
                onChange={(event) => {
                  const nextPurchaseType = event.target.value;
                  field.onChange(event);
                  if (nextPurchaseType === PURCHASE_TYPE_POST_PURCHASE && !isEditMode && Number(cruiseLeFee) === 0) {
                    setValue('payment_metadata.le_fee', DEFAULT_CRUISE_POST_PURCHASE_LE_FEE);
                  }
                }}
              >
                <MenuItem value={PURCHASE_TYPE_SALES}>Sales</MenuItem>
                <MenuItem value={PURCHASE_TYPE_POST_PURCHASE}>Post Purchase</MenuItem>
              </Select>
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          )}
        />
      </Grid>

      {purchaseType === PURCHASE_TYPE_POST_PURCHASE && (
        <Grid size={{ xs: 3, md: 1 }}>
          <Controller
            name="post_purchase_type"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth required error={!!error}>
                <InputLabel required>Post-Purchase Type</InputLabel>
                <Select
                  {...field}
                  label="Post-Purchase Type"
                  disabled={disabled}
                  data-testid="cruise-post-purchase-type"
                >
                  {CRUISE_POST_PURCHASE_TYPES.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
                {error && <FormHelperText>{error.message}</FormHelperText>}
              </FormControl>
            )}
          />
        </Grid>
      )}
    </>
  );
}
